/**
 * Meter.jsx
 * A no-framework meter input
 */
import React from 'react';

export const Meter = (props) => {
  return <meter {...props} />;
}
